import { Heading, Stack } from '@chakra-ui/react'
import { DocumentReference } from 'firebase/firestore'

import FirestoreUser, {
  Role,
  roleTitles,
} from '../../../../types/FirestoreUser'
import { RoleCheckbox } from './RoleCheckbox'

interface Props {
  user: FirestoreUser
  userRef: DocumentReference<FirestoreUser>
  adminName: string
}

export function RolesSection({ user, userRef, adminName }: Props) {
  return (
    <Stack spacing={2}>
      <Heading size='md'>Roles</Heading>
      {Object.keys(roleTitles).map((role) => {
        return (
          <RoleCheckbox
            key={role}
            role={role as Role}
            user={user}
            docRef={userRef}
            isDisabled={role === 'patient'}
            adminName={adminName}
          />
        )
      })}
    </Stack>
  )
}
